import IService from '../IService';

export default IService.extend({
  abortReadyMade: function () {
    if (app.xhrExpected(this.$ajax1)) {
      this.$ajax1.abort();
      this.$ajax1 = null;
    }
  },

  /**
   * @return {Promise}
   */
  getProgrammersForReadyMadeVideos: function () {
    this.abortReadyMade();

    return new Promise((resolve, reject) => {
      this.$ajax1 = $.ajax({
        url: app.apiUrl('/api/v1/discoverTabFilters'),
        error: (jqXHR, textStatus) => {
          if (textStatus !== 'abort') {
            reject(this.createError(jqXHR));
          }
        },
        success(response) {
          if (_.isObject(response)) {
            let { programmers, marketplaceProgrammers, categories } = response;

            // convert hash-map response to array of objects
            if (_.isObject(programmers)) {
              programmers = Object.keys(programmers).map((pId) => {
                return {
                  id: +pId,
                  label: programmers[pId],
                  _fromMarketplace: false,
                };
              });
            }
            if (_.isObject(marketplaceProgrammers)) {
              marketplaceProgrammers = Object.keys(marketplaceProgrammers).map(
                (pId) => {
                  return {
                    id: +pId,
                    label: marketplaceProgrammers[pId],
                    _fromMarketplace: true,
                  };
                }
              );
            }
            if (Array.isArray(categories)) {
              categories = categories.map((c) => {
                return { id: c.categoryId, label: c.categoryLabel };
              });
            }
            const allProgrammers = programmers.concat(marketplaceProgrammers);

            resolve({ programmers: allProgrammers, categories });
          } else {
            reject({ error: 'BAD_RESPONSE' });
          }
        },
      }).always(() => {
        this.$ajax1 = null;
      });
    });
  },
});
